"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9848],{

/***/ 14164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LR": function() { return /* binding */ getListing; },
/* harmony export */   "N": function() { return /* binding */ MAX_PAGE_SIZE; },
/* harmony export */   "PQ": function() { return /* binding */ GetListings; },
/* harmony export */   "vh": function() { return /* binding */ GetMapElements; },
/* harmony export */   "xL": function() { return /* binding */ reqListings; }
/* harmony export */ });
/* unused harmony exports reqListing, reqMarkers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88718);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50879);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55335);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82783);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61414);





var API_BASE_URL = "https://api.nika.production.casavo.tech";
var logChannel = "lisa.http.nika";
var MAX_PAGE_SIZE = 50;
var axios = axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].create */ .Z.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json"
    },
    timeout: 30000
});
function reqListings(filters, pagination, sort_by) {
    var params = {
        page: pagination ? pagination.page : 1
    };
    if (pagination && pagination.page_size) {
        params.page_size = pagination === null || pagination === void 0 ? void 0 : pagination.page_size;
    }
    if (sort_by) {
        params.sort_by = sort_by;
        if (Array.isArray(params.sort_by)) {
            params.sort_by = params.sort_by.join(",");
        }
    }
    if (filters) {
        params.where = JSON.stringify(filters);
    }
    return axios.get("/v2/listings/published", {
        params: params
    });
}
function reqListing(id) {
    return axios.get("/v2/listings/published/".concat(id));
}
function reqMarkers(filters, zoom) {
    var params = {
        zoom: zoom
    };
    if (filters) {
        params.where = JSON.stringify(filters);
    }
    return axios.get("/v2/listings/published/map/markers", {
        params: params
    });
}
function getListing(uuid) {
    return _getListing.apply(this, arguments);
}
function _getListing() {
    _getListing = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(uuid) {
        var data, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        reqListing(uuid)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    e = _state.sent();
                    _utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error({
                        channel: logChannel
                    }, "getListing ".concat(uuid, " - ").concat(e));
                    throw e;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getListing.apply(this, arguments);
}
function buildQueryKeyForIndex(name, filters, pagination, sort_by) {
    return [
        name,
        sort_by || "-updated_at",
        pagination ? pagination.page_size : "20",
        pagination ? pagination.page : "1",
        filters ? JSON.stringify(filters) : "{}", 
    ];
}
function GetListings(filters, pagination, sort_by, options) {
    var key = buildQueryKeyForIndex("listings-index", filters, pagination, sort_by);
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(key, function() {
        var inner = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var data, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                reqListings(filters, pagination, sort_by)
                            ];
                        case 1:
                            data = _state.sent().data;
                            return [
                                2,
                                data
                            ];
                        case 2:
                            e = _state.sent();
                            _utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error({
                                channel: logChannel
                            }, "reqListings - ".concat(e));
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function inner() {
                return _ref.apply(this, arguments);
            };
        }();
        return inner();
    }, options);
}
function GetMarkers(filters, zoom, options) {
    var key = buildQueryKeyForIndex("markers-index", filters, {
        page: zoom,
        page_size: 0
    }, null);
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(key, function() {
        var inner = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var data, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            if (!filters) {
                                return [
                                    2,
                                    {
                                        data: [],
                                        meta: {}
                                    }
                                ];
                            }
                            return [
                                4,
                                reqMarkers(filters, zoom)
                            ];
                        case 1:
                            data = _state.sent().data;
                            return [
                                2,
                                data
                            ];
                        case 2:
                            e = _state.sent();
                            _utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error({
                                channel: logChannel
                            }, "reqMarkers - ".concat(e));
                            throw e;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function inner() {
                return _ref.apply(this, arguments);
            };
        }();
        return inner();
    }, options);
}
function GetMapElements(maxZoom, filters, zoom, options) {
    if (zoom === maxZoom) {
        return GetListings(filters, {
            page: 1,
            page_size: 50
        }, null, options);
    }
    return GetMarkers(filters, zoom, options);
}


/***/ }),

/***/ 59850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ ModalBase; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/Close/index.tsx
var Close = __webpack_require__(87411);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/utils/css-utils.ts
var css_utils = __webpack_require__(22106);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
;// CONCATENATED MODULE: ./src/components/Modal/ModalBase/styles.css.ts

var modalBase = 'tfghjgjr tfghjgg9 tfghjghf tfghjgil tfghjg1u tfghjg7l tfghjga3 tfghjga6';
;// CONCATENATED MODULE: ./src/components/Modal/ModalBase/index.tsx









var ModalBase = function(param) {
    var backToInitialScroll = param.backToInitialScroll, children = param.children, className = param.className, handleClose = param.handleClose, noPadding = param.noPadding;
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(modalBase, className),
        style: {
            padding: noPadding && 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                ariaLabel: "Close",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    position: "absolute",
                    right: "m",
                    top: "m",
                    zIndex: (0,css_utils/* zIndex */.W)("modalContent")
                }),
                Icon: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                },
                shapeVariant: "round",
                styleVariant: "tertiary",
                onClick: function() {
                    closeModal({
                        shouldBackToInitialScroll: backToInitialScroll
                    });
                    handleClose && handleClose();
                }
            }),
            children
        ]
    });
};


/***/ }),

/***/ 25852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49392);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _types_cate_graphql_generated_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73559);
/* harmony import */ var _utils_uuid_request_id__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33973);



function createCateGraphQLClient(endpoint) {
    var client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(endpoint, {
        headers: {
            "X-Request-ID": (0,_utils_uuid_request_id__WEBPACK_IMPORTED_MODULE_2__/* .generateUuidRequestId */ .l)()
        }
    });
    return (0,_types_cate_graphql_generated_types__WEBPACK_IMPORTED_MODULE_1__/* .getSdk */ .mK)(client);
}
var cateGraphQLClient = createCateGraphQLClient("https://hasura.cate.production.casavo.tech/v1/graphql");
/* harmony default export */ __webpack_exports__["Z"] = (cateGraphQLClient);


/***/ }),

/***/ 73559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lq": function() { return /* binding */ Order_By; },
/* harmony export */   "mK": function() { return /* binding */ getSdk; }
/* harmony export */ });
/* unused harmony exports Additional_Info_Select_Column, Addresses_Select_Column, Balconies_Select_Column, Boxes_Select_Column, Characteristics_Select_Column, Cities_Select_Column, City_Zones_Select_Column, Condo_Fees_Per_Year_Select_Column, Contact_Info_Select_Column, Descriptions_Select_Column, Detail_Select_Column, Floors_Select_Column, Furnishing_Proposals_Select_Column, Listings_Detail_Select_Column, Photos_Select_Column, Planimetries_Select_Column, Points_Of_Interest_Select_Column, Potential_Property_Floors_Select_Column, Potential_Property_Media_Select_Column, Potential_Property_Select_Column, Public_Urls_Select_Column, Selling_Prices_Select_Column, Services_Select_Column, Terraces_Select_Column, Titles_Select_Column, Translations_Select_Column, Virtual_Tours_Select_Column, Zones_Select_Column, AllListingsDocument, ListingBySlugAndZoneDocument, FavouriteListingsDesktopDocument, ListingsByFilterDocument, ListingsByIdsDocument, ListingsBySimilarDocument, ListingsCountDocument, FavouriteListingsDocument, ListingsMarkerDocument, PotentialPropertyByFilterDocument, PotentialPropertiesBySimilarDocument, PotentialPropertyDocument, PotentialPropertiesBySuggestedCriteriaDocument */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84283);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48000);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query allListings {\n  listingsDetailCate {\n    detail {\n      city\n      zone {\n        slug\n      }\n    }\n    slug\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query listingBySlugAndZone($slug: String!, $zone: String!) {\n  listingsDetailCate(\n    where: {_and: [{slug: {_eq: $slug}}, {_or: [{detail: {zone: {slug: {_eq: $zone}}}}, {detail: {city: {_eq: $zone}}}]}]}\n  ) {\n    addressesCate {\n      street\n      streetNumber\n      zipCode\n    }\n    additionalInfo {\n      views\n      constructionYear\n      condo\n      condoFeesPerYearCate {\n        cents\n        currency\n      }\n      exposure\n      glazing\n      furnishings\n      heatingSystem\n      kitchen\n      lastRenovationYear\n      stateAtDeed\n      superCondo\n      coolingSystem\n      energyPerformanceIndex\n      energyRating\n      estateRegistryClass\n    }\n    descriptions {\n      language\n      neighbourhoodDescription\n      propertyDescription\n    }\n    detail {\n      transactionId\n      sellingUnitId\n      casavoDirectSale\n      city\n      commercialArea\n      buildingFloors\n      entireBuilding\n      entranceFloor\n      floorPosition\n      exclusiveSellingMandate\n      floors {\n        buildingFloor\n        entireFloor\n        floorShift\n      }\n      inventory\n      privateNegotiation\n      salesPipeline\n      sellingPrices {\n        cents\n        currency\n      }\n      titles {\n        language\n        text\n      }\n      zone {\n        label\n        slug\n      }\n    }\n    characteristics {\n      balconies {\n        area\n        areas\n        counter\n      }\n      bathrooms\n      bedrooms\n      rooms\n      stateOfMaintenance\n      terraces {\n        area\n        areas\n        counter\n      }\n    }\n    contactInfo {\n      agencyAddress\n      agencyLogo\n      agencyName\n      agencyWebsite\n      emailContact\n      ownedByCasavo\n      telephoneNumberContact\n    }\n    coordinates\n    country\n    furnishingProposals {\n      url\n      price\n    }\n    photos(order_by: {order: asc}) {\n      isPrimary\n      order\n      url\n    }\n    planimetries {\n      url\n    }\n    pointsOfInterest {\n      coordinates\n      distance\n      name\n      poiType\n    }\n    publicUrls {\n      language\n      url\n    }\n    virtualTours {\n      url\n    }\n    services {\n      alarmSystem\n      armoredDoor\n      basement\n      box {\n        area\n        areas\n        counter\n      }\n      conciergeService\n      disabledAccess\n      disabledFriendly\n      electricGate\n      elevator\n      entranceVideoPhone\n      fastInternet\n      fireplace\n      garden\n      garret\n      hydromassage\n      parkingSpaces\n      pool\n      recreationRoom\n      satelliteSystem\n      sharedPool\n      tennisCourt\n      tvSystem\n      walkingArea\n      wallCabinet\n    }\n    slug\n    showStreetNumber\n    residentialType\n    coordinates\n    id\n    insertedAt\n    updatedAt\n  }\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query favouriteListingsDesktop($ids: [uuid!]!) {\n  listingsDetailCate(where: {id: {_in: $ids}}) {\n    id\n    coordinates\n    slug\n    additionalInfo {\n      energyRating\n    }\n    characteristics {\n      bathrooms\n      bedrooms\n      rooms\n      stateOfMaintenance\n      terraces {\n        area\n        areas\n        counter\n      }\n    }\n    contactInfo {\n      agencyName\n      agencyLogo\n      ownedByCasavo\n    }\n    descriptions {\n      language\n      neighbourhoodDescription\n      propertyDescription\n    }\n    detail {\n      inventory\n      city\n      commercialArea\n      entranceFloor\n      entireBuilding\n      buildingFloors\n      floorPosition\n      sellingPrices {\n        cents\n        currency\n      }\n      titles {\n        text\n        language\n      }\n      zone {\n        slug\n        label\n      }\n    }\n    services {\n      garden\n    }\n    photos {\n      isPrimary\n      url\n    }\n    virtualTours {\n      url\n    }\n  }\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query listingsByFilter($where: listings_detail_bool_exp, $orderBy: [listings_detail_order_by!], $limit: Int, $offset: Int) {\n  listingsDetailCate(\n    where: $where\n    order_by: $orderBy\n    limit: $limit\n    offset: $offset\n  ) {\n    id\n    slug\n    additionalInfo {\n      energyRating\n    }\n    detail {\n      inventory\n      entranceFloor\n      floorPosition\n      titles {\n        text\n        language\n      }\n      buildingFloors\n      city\n      commercialArea\n      entireBuilding\n      privateNegotiation\n      zone {\n        slug\n        label\n      }\n      sellingPrices {\n        cents\n        currency\n      }\n    }\n    contactInfo {\n      ownedByCasavo\n      agencyLogo\n      agencyName\n    }\n    characteristics {\n      bathrooms\n      bedrooms\n      rooms\n      stateOfMaintenance\n      terraces {\n        counter\n        area\n        areas\n      }\n    }\n    publishedAt\n    services {\n      garden\n    }\n    descriptions {\n      propertyDescription\n      neighbourhoodDescription\n      language\n    }\n    addressesCate {\n      street\n      streetNumber\n    }\n    photos(order_by: {order: asc}) {\n      isPrimary\n      order\n      url\n    }\n    virtualTours {\n      url\n    }\n    coordinates\n  }\n  listings_detail_aggregate(where: $where) {\n    aggregate {\n      count\n    }\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query listingsByIds($ids: [uuid!]!) {\n  listingsDetailCate(where: {id: {_in: $ids}}) {\n    id\n    addressesCate {\n      street\n      streetNumber\n      zipCode\n    }\n    additionalInfo {\n      energyRating\n    }\n    detail {\n      sellingPrices {\n        cents\n        currency\n      }\n      entranceFloor\n      buildingFloors\n      casavoDirectSale\n      city\n      commercialArea\n      floorPosition\n      entireBuilding\n      inventory\n      privateNegotiation\n      titles {\n        language\n        text\n      }\n      zone {\n        label\n        slug\n      }\n    }\n    characteristics {\n      bathrooms\n      bedrooms\n      rooms\n      stateOfMaintenance\n      terraces {\n        area\n        areas\n        counter\n      }\n    }\n    contactInfo {\n      ownedByCasavo\n    }\n    photos(order_by: {order: asc}) {\n      isPrimary\n      order\n      url\n    }\n    virtualTours {\n      url\n    }\n    services {\n      garden\n    }\n    slug\n    publishedAt\n  }\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query listingsBySimilar($priceMin: bigint!, $priceMax: bigint!, $areaMin: Int!, $areaMax: Int!, $roomsMin: Int!, $roomsMax: Int!, $geoSlugs: [String!]!) {\n  listingsDetailCate(\n    where: {characteristics: {rooms: {_gte: $roomsMin, _lte: $roomsMax}}, detail: {_or: [{zone: {slug: {_in: $geoSlugs}}}, {city: {_in: $geoSlugs}}], sellingPrices: {cents: {_gte: $priceMin, _lte: $priceMax}}, commercialArea: {_gte: $areaMin, _lte: $areaMax}}}\n    limit: 10\n  ) {\n    id\n    coordinates\n    slug\n    additionalInfo {\n      energyRating\n    }\n    characteristics {\n      bathrooms\n      bedrooms\n      rooms\n      stateOfMaintenance\n      terraces {\n        area\n        areas\n        counter\n      }\n    }\n    contactInfo {\n      agencyName\n      agencyLogo\n      ownedByCasavo\n    }\n    descriptions {\n      language\n      neighbourhoodDescription\n      propertyDescription\n    }\n    detail {\n      inventory\n      city\n      commercialArea\n      entranceFloor\n      entireBuilding\n      buildingFloors\n      floorPosition\n      sellingPrices {\n        cents\n        currency\n      }\n      titles {\n        text\n        language\n      }\n      zone {\n        slug\n        label\n      }\n    }\n    services {\n      garden\n    }\n    photos {\n      isPrimary\n      url\n    }\n    virtualTours {\n      url\n    }\n  }\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query listingsCount($where: listings_detail_bool_exp) {\n  listings_detail_aggregate(where: $where) {\n    aggregate {\n      count\n    }\n  }\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query favouriteListings($ids: [uuid!]!) {\n  listingsDetailCate(where: {id: {_in: $ids}}) {\n    id\n    slug\n    primaryPhoto: photos(limit: 1, where: {isPrimary: {_eq: true}}) {\n      url\n    }\n    fallbackPhoto: photos(limit: 1, order_by: {order: asc}) {\n      url\n    }\n    detail {\n      inventory\n      commercialArea\n      city\n      privateNegotiation\n      zone {\n        slug\n      }\n      titles {\n        text\n        language\n      }\n      sellingPrices {\n        cents\n        currency\n      }\n    }\n    contactInfo {\n      ownedByCasavo\n    }\n    additionalInfo {\n      energyRating\n      energyRatingCategory\n    }\n    photos {\n      isPrimary\n      url\n    }\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query listingsMarker($where: listings_detail_bool_exp, $orderBy: [listings_detail_order_by!], $limit: Int, $offset: Int) {\n  listingsDetailCate(\n    where: $where\n    order_by: $orderBy\n    limit: $limit\n    offset: $offset\n  ) {\n    id\n    coordinates\n    contactInfo {\n      ownedByCasavo\n    }\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query potentialPropertyByFilter($where: potential_property_bool_exp, $offset: Int!, $orderBy: [potential_property_order_by!], $limit: Int!) {\n  potential_property(\n    where: $where\n    limit: $limit\n    offset: $offset\n    order_by: $orderBy\n  ) {\n    potentialPropertyMedia {\n      roomType\n      url\n      imageCategory\n      roomTypeConfidence\n    }\n    transactionId\n    city\n    title\n    slug\n    rooms\n    bathrooms\n    stateOfMaintenance\n    commercialArea\n    askedPrice\n    valuation\n    zone\n    insertedAt\n    estimatedListingPrice\n    status\n    energyRatingClass\n    entranceFloor\n    buildingFloors\n  }\n  potential_property_aggregate(where: $where) {\n    aggregate {\n      count\n    }\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query potentialPropertiesBySimilar($priceMin: Int!, $priceMax: Int!, $areaMin: Int!, $areaMax: Int!, $roomsMin: Int!, $roomsMax: Int!, $geoSlugs: [String!]!) {\n  potential_property(\n    where: {_and: [{isPresentable: {_eq: true}}, {rooms: {_gte: $roomsMin, _lte: $roomsMax}}, {_or: [{zoneSlug: {_in: $geoSlugs}}, {city: {_in: $geoSlugs}}]}, {askedPriceInCents: {_gte: $priceMin, _lte: $priceMax}}, {commercialArea: {_gte: $areaMin, _lte: $areaMax}}]}\n    limit: 10\n  ) {\n    isPresentable\n    askedPrice\n    bathrooms\n    city\n    commercialArea\n    estimatedListingPrice\n    potentialPropertyMedia {\n      roomType\n      url\n      imageCategory\n      roomTypeConfidence\n    }\n    rooms\n    slug\n    stateOfMaintenance\n    status\n    title\n    transactionId\n    terraceAreas\n    zone\n    buildingFloors\n    entranceFloor\n    gardenArea\n    energyRatingClass\n    insertedAt\n  }\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query potentialProperty($slug: String!, $isPresentable: Boolean = true) {\n  potential_property(\n    where: {_and: [{slug: {_eq: $slug}}, {isPresentable: {_eq: $isPresentable}}, {title: {_is_null: false}}, {city: {_is_null: false}}, {rooms: {_is_null: false}}, {slug: {_is_null: false}}, {commercialArea: {_is_null: false}}, {bathrooms: {_is_null: false}}, {coordinates: {_is_null: false}}, {entranceFloor: {_is_null: false}}, {stateOfMaintenance: {_is_null: false}}, {residentialType: {_is_null: false}}, {_or: [{askedPrice: {_is_null: false}}, {valuation: {_is_null: false}}]}]}\n  ) {\n    transactionId\n    entranceFloor\n    city\n    balconies\n    bathrooms\n    buildingFloors\n    commercialArea\n    constructionYear\n    slug\n    isPresentable\n    updatedAt\n    insertedAt\n    potentialPropertyMedia {\n      roomType\n      url\n      imageCategory\n      roomTypeConfidence\n    }\n    title\n    potentialPropertyFloors {\n      entireFloor\n      floorShift\n      buildingFloor\n    }\n    askedPrice\n    estimatedListingPrice\n    heatingSystem\n    country\n    energyRatingClass\n    gardenArea\n    hasElevator\n    hasPool\n    boxAreas\n    expirationDate\n    stateOfMaintenance\n    rooms\n    valuation\n    zone\n    status\n  }\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query potentialPropertiesBySuggestedCriteria($priceMax: Int!, $roomsMin: Int!, $geoSlugs: [String!]!) {\n  potential_property(\n    where: {_and: [{isPresentable: {_eq: true}}, {title: {_is_null: false}}, {slug: {_is_null: false}}, {commercialArea: {_is_null: false}}, {bathrooms: {_is_null: false}}, {coordinates: {_is_null: false}}, {entranceFloor: {_is_null: false}}, {stateOfMaintenance: {_is_null: false}}, {residentialType: {_is_null: false}}, {_or: [{zoneSlug: {_in: $geoSlugs}}, {city: {_in: $geoSlugs}}]}, {_or: [{askedPriceInCents: {_lte: $priceMax}}, {valuationPriceInCents: {_lte: $priceMax}}]}, {rooms: {_gte: $roomsMin}}]}\n    limit: 20\n    order_by: {firstPublishedAt: desc}\n  ) {\n    transactionId\n    entranceFloor\n    city\n    bathrooms\n    buildingFloors\n    commercialArea\n    slug\n    potentialPropertyMedia {\n      roomType\n      url\n      imageCategory\n    }\n    title\n    energyRatingClass\n    gardenArea\n    stateOfMaintenance\n    rooms\n    terraceAreas\n    askedPriceInCents\n    valuationPriceInCents\n    zone\n    askedPrice\n    valuation\n    status\n    estimatedListingPrice\n    insertedAt\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var Additional_Info_Select_Column;
(function(Additional_Info_Select_Column) {
    Additional_Info_Select_Column[/** column name */ "Condo"] = "condo";
    Additional_Info_Select_Column[/** column name */ "CondoFeesPerYear"] = "condoFeesPerYear";
    Additional_Info_Select_Column[/** column name */ "ConstructionYear"] = "constructionYear";
    Additional_Info_Select_Column[/** column name */ "CoolingSystem"] = "coolingSystem";
    Additional_Info_Select_Column[/** column name */ "EnergyPerformanceIndex"] = "energyPerformanceIndex";
    Additional_Info_Select_Column[/** column name */ "EnergyRating"] = "energyRating";
    Additional_Info_Select_Column[/** column name */ "EnergyRatingCategory"] = "energyRatingCategory";
    Additional_Info_Select_Column[/** column name */ "EstateRegistryArea"] = "estateRegistryArea";
    Additional_Info_Select_Column[/** column name */ "EstateRegistryClass"] = "estateRegistryClass";
    Additional_Info_Select_Column[/** column name */ "Exposure"] = "exposure";
    Additional_Info_Select_Column[/** column name */ "Furnishings"] = "furnishings";
    Additional_Info_Select_Column[/** column name */ "Glazing"] = "glazing";
    Additional_Info_Select_Column[/** column name */ "HeatingSystem"] = "heatingSystem";
    Additional_Info_Select_Column[/** column name */ "Kitchen"] = "kitchen";
    Additional_Info_Select_Column[/** column name */ "LastRenovationYear"] = "lastRenovationYear";
    Additional_Info_Select_Column[/** column name */ "StateAtDeed"] = "stateAtDeed";
    Additional_Info_Select_Column[/** column name */ "SuperCondo"] = "superCondo";
    Additional_Info_Select_Column[/** column name */ "Views"] = "views";
})(Additional_Info_Select_Column || (Additional_Info_Select_Column = {}));
var Addresses_Select_Column;
(function(Addresses_Select_Column) {
    Addresses_Select_Column[/** column name */ "Street"] = "street";
    Addresses_Select_Column[/** column name */ "StreetNumber"] = "streetNumber";
    Addresses_Select_Column[/** column name */ "ZipCode"] = "zipCode";
})(Addresses_Select_Column || (Addresses_Select_Column = {}));
var Balconies_Select_Column;
(function(Balconies_Select_Column) {
    Balconies_Select_Column[/** column name */ "Area"] = "area";
    Balconies_Select_Column[/** column name */ "Areas"] = "areas";
    Balconies_Select_Column[/** column name */ "Counter"] = "counter";
})(Balconies_Select_Column || (Balconies_Select_Column = {}));
var Boxes_Select_Column;
(function(Boxes_Select_Column) {
    Boxes_Select_Column[/** column name */ "Area"] = "area";
    Boxes_Select_Column[/** column name */ "Areas"] = "areas";
    Boxes_Select_Column[/** column name */ "Counter"] = "counter";
})(Boxes_Select_Column || (Boxes_Select_Column = {}));
var Characteristics_Select_Column;
(function(Characteristics_Select_Column) {
    Characteristics_Select_Column[/** column name */ "Bathrooms"] = "bathrooms";
    Characteristics_Select_Column[/** column name */ "Bedrooms"] = "bedrooms";
    Characteristics_Select_Column[/** column name */ "Rooms"] = "rooms";
    Characteristics_Select_Column[/** column name */ "StateOfMaintenance"] = "stateOfMaintenance";
})(Characteristics_Select_Column || (Characteristics_Select_Column = {}));
var Cities_Select_Column;
(function(Cities_Select_Column) {
    Cities_Select_Column[/** column name */ "Abbreviation"] = "abbreviation";
    Cities_Select_Column[/** column name */ "Center"] = "center";
    Cities_Select_Column[/** column name */ "Country"] = "country";
    Cities_Select_Column[/** column name */ "Name"] = "name";
    Cities_Select_Column[/** column name */ "ReferenceArea"] = "referenceArea";
    Cities_Select_Column[/** column name */ "Slug"] = "slug";
})(Cities_Select_Column || (Cities_Select_Column = {}));
var City_Zones_Select_Column;
(function(City_Zones_Select_Column) {
    City_Zones_Select_Column[/** column name */ "Label"] = "label";
    City_Zones_Select_Column[/** column name */ "Slug"] = "slug";
})(City_Zones_Select_Column || (City_Zones_Select_Column = {}));
var Condo_Fees_Per_Year_Select_Column;
(function(Condo_Fees_Per_Year_Select_Column) {
    Condo_Fees_Per_Year_Select_Column[/** column name */ "Cents"] = "cents";
    Condo_Fees_Per_Year_Select_Column[/** column name */ "Currency"] = "currency";
})(Condo_Fees_Per_Year_Select_Column || (Condo_Fees_Per_Year_Select_Column = {}));
var Contact_Info_Select_Column;
(function(Contact_Info_Select_Column) {
    Contact_Info_Select_Column[/** column name */ "AgencyAddress"] = "agencyAddress";
    Contact_Info_Select_Column[/** column name */ "AgencyLogo"] = "agencyLogo";
    Contact_Info_Select_Column[/** column name */ "AgencyName"] = "agencyName";
    Contact_Info_Select_Column[/** column name */ "AgencyWebsite"] = "agencyWebsite";
    Contact_Info_Select_Column[/** column name */ "EmailContact"] = "emailContact";
    Contact_Info_Select_Column[/** column name */ "OwnedByCasavo"] = "ownedByCasavo";
    Contact_Info_Select_Column[/** column name */ "TelephoneNumberContact"] = "telephoneNumberContact";
})(Contact_Info_Select_Column || (Contact_Info_Select_Column = {}));
var Descriptions_Select_Column;
(function(Descriptions_Select_Column) {
    Descriptions_Select_Column[/** column name */ "Language"] = "language";
    Descriptions_Select_Column[/** column name */ "NeighbourhoodDescription"] = "neighbourhoodDescription";
    Descriptions_Select_Column[/** column name */ "PropertyDescription"] = "propertyDescription";
})(Descriptions_Select_Column || (Descriptions_Select_Column = {}));
var Detail_Select_Column;
(function(Detail_Select_Column) {
    Detail_Select_Column[/** column name */ "BuildingFloors"] = "buildingFloors";
    Detail_Select_Column[/** column name */ "CasavoDirectSale"] = "casavoDirectSale";
    Detail_Select_Column[/** column name */ "City"] = "city";
    Detail_Select_Column[/** column name */ "CommercialArea"] = "commercialArea";
    Detail_Select_Column[/** column name */ "EntireBuilding"] = "entireBuilding";
    Detail_Select_Column[/** column name */ "EntranceFloor"] = "entranceFloor";
    Detail_Select_Column[/** column name */ "ExclusiveSellingMandate"] = "exclusiveSellingMandate";
    Detail_Select_Column[/** column name */ "FloorPosition"] = "floorPosition";
    Detail_Select_Column[/** column name */ "Inventory"] = "inventory";
    Detail_Select_Column[/** column name */ "PrivateNegotiation"] = "privateNegotiation";
    Detail_Select_Column[/** column name */ "SalesPipeline"] = "salesPipeline";
    Detail_Select_Column[/** column name */ "SellingUnitId"] = "sellingUnitId";
    Detail_Select_Column[/** column name */ "TransactionId"] = "transactionId";
})(Detail_Select_Column || (Detail_Select_Column = {}));
var Floors_Select_Column;
(function(Floors_Select_Column) {
    Floors_Select_Column[/** column name */ "BuildingFloor"] = "buildingFloor";
    Floors_Select_Column[/** column name */ "EntireFloor"] = "entireFloor";
    Floors_Select_Column[/** column name */ "FloorShift"] = "floorShift";
})(Floors_Select_Column || (Floors_Select_Column = {}));
var Furnishing_Proposals_Select_Column;
(function(Furnishing_Proposals_Select_Column) {
    Furnishing_Proposals_Select_Column[/** column name */ "Price"] = "price";
    Furnishing_Proposals_Select_Column[/** column name */ "Url"] = "url";
})(Furnishing_Proposals_Select_Column || (Furnishing_Proposals_Select_Column = {}));
var Listings_Detail_Select_Column;
(function(Listings_Detail_Select_Column) {
    Listings_Detail_Select_Column[/** column name */ "Coordinates"] = "coordinates";
    Listings_Detail_Select_Column[/** column name */ "Country"] = "country";
    Listings_Detail_Select_Column[/** column name */ "Id"] = "id";
    Listings_Detail_Select_Column[/** column name */ "InsertedAt"] = "insertedAt";
    Listings_Detail_Select_Column[/** column name */ "PublishedAt"] = "publishedAt";
    Listings_Detail_Select_Column[/** column name */ "Ranking"] = "ranking";
    Listings_Detail_Select_Column[/** column name */ "ResidentialType"] = "residentialType";
    Listings_Detail_Select_Column[/** column name */ "ShowStreetNumber"] = "showStreetNumber";
    Listings_Detail_Select_Column[/** column name */ "Slug"] = "slug";
    Listings_Detail_Select_Column[/** column name */ "UpdatedAt"] = "updatedAt";
})(Listings_Detail_Select_Column || (Listings_Detail_Select_Column = {}));
var Order_By;
(function(Order_By) {
    Order_By[/** in the ascending order, nulls last */ "Asc"] = "asc";
    Order_By[/** in the ascending order, nulls first */ "AscNullsFirst"] = "asc_nulls_first";
    Order_By[/** in the ascending order, nulls last */ "AscNullsLast"] = "asc_nulls_last";
    Order_By[/** in the descending order, nulls first */ "Desc"] = "desc";
    Order_By[/** in the descending order, nulls first */ "DescNullsFirst"] = "desc_nulls_first";
    Order_By[/** in the descending order, nulls last */ "DescNullsLast"] = "desc_nulls_last";
})(Order_By || (Order_By = {}));
var Photos_Select_Column;
(function(Photos_Select_Column) {
    Photos_Select_Column[/** column name */ "IsPrimary"] = "isPrimary";
    Photos_Select_Column[/** column name */ "Order"] = "order";
    Photos_Select_Column[/** column name */ "Url"] = "url";
})(Photos_Select_Column || (Photos_Select_Column = {}));
var Planimetries_Select_Column;
(function(Planimetries_Select_Column) {
    Planimetries_Select_Column[/** column name */ "Url"] = "url";
})(Planimetries_Select_Column || (Planimetries_Select_Column = {}));
var Points_Of_Interest_Select_Column;
(function(Points_Of_Interest_Select_Column) {
    Points_Of_Interest_Select_Column[/** column name */ "Coordinates"] = "coordinates";
    Points_Of_Interest_Select_Column[/** column name */ "Distance"] = "distance";
    Points_Of_Interest_Select_Column[/** column name */ "Name"] = "name";
    Points_Of_Interest_Select_Column[/** column name */ "PoiType"] = "poiType";
})(Points_Of_Interest_Select_Column || (Points_Of_Interest_Select_Column = {}));
var Potential_Property_Floors_Select_Column;
(function(Potential_Property_Floors_Select_Column) {
    Potential_Property_Floors_Select_Column[/** column name */ "BuildingFloor"] = "buildingFloor";
    Potential_Property_Floors_Select_Column[/** column name */ "EntireFloor"] = "entireFloor";
    Potential_Property_Floors_Select_Column[/** column name */ "FloorShift"] = "floorShift";
})(Potential_Property_Floors_Select_Column || (Potential_Property_Floors_Select_Column = {}));
var Potential_Property_Media_Select_Column;
(function(Potential_Property_Media_Select_Column) {
    Potential_Property_Media_Select_Column[/** column name */ "ImageCategory"] = "imageCategory";
    Potential_Property_Media_Select_Column[/** column name */ "RoomType"] = "roomType";
    Potential_Property_Media_Select_Column[/** column name */ "RoomTypeConfidence"] = "roomTypeConfidence";
    Potential_Property_Media_Select_Column[/** column name */ "Url"] = "url";
})(Potential_Property_Media_Select_Column || (Potential_Property_Media_Select_Column = {}));
var Potential_Property_Select_Column;
(function(Potential_Property_Select_Column) {
    Potential_Property_Select_Column[/** column name */ "AskedPrice"] = "askedPrice";
    Potential_Property_Select_Column[/** column name */ "AskedPriceInCents"] = "askedPriceInCents";
    Potential_Property_Select_Column[/** column name */ "Balconies"] = "balconies";
    Potential_Property_Select_Column[/** column name */ "Bathrooms"] = "bathrooms";
    Potential_Property_Select_Column[/** column name */ "BoxAreas"] = "boxAreas";
    Potential_Property_Select_Column[/** column name */ "BuildingFloors"] = "buildingFloors";
    Potential_Property_Select_Column[/** column name */ "City"] = "city";
    Potential_Property_Select_Column[/** column name */ "CommercialArea"] = "commercialArea";
    Potential_Property_Select_Column[/** column name */ "ConstructionYear"] = "constructionYear";
    Potential_Property_Select_Column[/** column name */ "Coordinates"] = "coordinates";
    Potential_Property_Select_Column[/** column name */ "Country"] = "country";
    Potential_Property_Select_Column[/** column name */ "EnergyRatingClass"] = "energyRatingClass";
    Potential_Property_Select_Column[/** column name */ "EntranceFloor"] = "entranceFloor";
    Potential_Property_Select_Column[/** column name */ "EstimatedListingPrice"] = "estimatedListingPrice";
    Potential_Property_Select_Column[/** column name */ "ExpirationDate"] = "expirationDate";
    Potential_Property_Select_Column[/** column name */ "FirstPublishedAt"] = "firstPublishedAt";
    Potential_Property_Select_Column[/** column name */ "GardenArea"] = "gardenArea";
    Potential_Property_Select_Column[/** column name */ "HasElevator"] = "hasElevator";
    Potential_Property_Select_Column[/** column name */ "HasPool"] = "hasPool";
    Potential_Property_Select_Column[/** column name */ "HeatingSystem"] = "heatingSystem";
    Potential_Property_Select_Column[/** column name */ "InsertedAt"] = "insertedAt";
    Potential_Property_Select_Column[/** column name */ "IsPresentable"] = "isPresentable";
    Potential_Property_Select_Column[/** column name */ "Metadata"] = "metadata";
    Potential_Property_Select_Column[/** column name */ "OffMarketSince"] = "offMarketSince";
    Potential_Property_Select_Column[/** column name */ "RefusalReasons"] = "refusalReasons";
    Potential_Property_Select_Column[/** column name */ "RefusedAt"] = "refusedAt";
    Potential_Property_Select_Column[/** column name */ "ResidentialType"] = "residentialType";
    Potential_Property_Select_Column[/** column name */ "Rooms"] = "rooms";
    Potential_Property_Select_Column[/** column name */ "Slug"] = "slug";
    Potential_Property_Select_Column[/** column name */ "StateAtDeed"] = "stateAtDeed";
    Potential_Property_Select_Column[/** column name */ "StateOfMaintenance"] = "stateOfMaintenance";
    Potential_Property_Select_Column[/** column name */ "Status"] = "status";
    Potential_Property_Select_Column[/** column name */ "Street"] = "street";
    Potential_Property_Select_Column[/** column name */ "StreetNumber"] = "streetNumber";
    Potential_Property_Select_Column[/** column name */ "Tenant"] = "tenant";
    Potential_Property_Select_Column[/** column name */ "TerraceAreas"] = "terraceAreas";
    Potential_Property_Select_Column[/** column name */ "Title"] = "title";
    Potential_Property_Select_Column[/** column name */ "TransactionId"] = "transactionId";
    Potential_Property_Select_Column[/** column name */ "UpdatedAt"] = "updatedAt";
    Potential_Property_Select_Column[/** column name */ "Valuation"] = "valuation";
    Potential_Property_Select_Column[/** column name */ "ValuationPriceInCents"] = "valuationPriceInCents";
    Potential_Property_Select_Column[/** column name */ "ViewDescription"] = "viewDescription";
    Potential_Property_Select_Column[/** column name */ "ZipCode"] = "zipCode";
    Potential_Property_Select_Column[/** column name */ "Zone"] = "zone";
    Potential_Property_Select_Column[/** column name */ "ZoneSlug"] = "zoneSlug";
})(Potential_Property_Select_Column || (Potential_Property_Select_Column = {}));
var Public_Urls_Select_Column;
(function(Public_Urls_Select_Column) {
    Public_Urls_Select_Column[/** column name */ "Language"] = "language";
    Public_Urls_Select_Column[/** column name */ "Url"] = "url";
})(Public_Urls_Select_Column || (Public_Urls_Select_Column = {}));
var Selling_Prices_Select_Column;
(function(Selling_Prices_Select_Column) {
    Selling_Prices_Select_Column[/** column name */ "Cents"] = "cents";
    Selling_Prices_Select_Column[/** column name */ "Currency"] = "currency";
})(Selling_Prices_Select_Column || (Selling_Prices_Select_Column = {}));
var Services_Select_Column;
(function(Services_Select_Column) {
    Services_Select_Column[/** column name */ "AlarmSystem"] = "alarmSystem";
    Services_Select_Column[/** column name */ "ArmoredDoor"] = "armoredDoor";
    Services_Select_Column[/** column name */ "Basement"] = "basement";
    Services_Select_Column[/** column name */ "ConciergeService"] = "conciergeService";
    Services_Select_Column[/** column name */ "DisabledAccess"] = "disabledAccess";
    Services_Select_Column[/** column name */ "DisabledFriendly"] = "disabledFriendly";
    Services_Select_Column[/** column name */ "ElectricGate"] = "electricGate";
    Services_Select_Column[/** column name */ "Elevator"] = "elevator";
    Services_Select_Column[/** column name */ "EntranceVideoPhone"] = "entranceVideoPhone";
    Services_Select_Column[/** column name */ "FastInternet"] = "fastInternet";
    Services_Select_Column[/** column name */ "Fireplace"] = "fireplace";
    Services_Select_Column[/** column name */ "Garden"] = "garden";
    Services_Select_Column[/** column name */ "GardenArea"] = "gardenArea";
    Services_Select_Column[/** column name */ "Garret"] = "garret";
    Services_Select_Column[/** column name */ "HomeAutomationSystem"] = "homeAutomationSystem";
    Services_Select_Column[/** column name */ "Hydromassage"] = "hydromassage";
    Services_Select_Column[/** column name */ "ParkingSpaces"] = "parkingSpaces";
    Services_Select_Column[/** column name */ "Pool"] = "pool";
    Services_Select_Column[/** column name */ "RecreationRoom"] = "recreationRoom";
    Services_Select_Column[/** column name */ "SatelliteSystem"] = "satelliteSystem";
    Services_Select_Column[/** column name */ "SharedPool"] = "sharedPool";
    Services_Select_Column[/** column name */ "TennisCourt"] = "tennisCourt";
    Services_Select_Column[/** column name */ "TvSystem"] = "tvSystem";
    Services_Select_Column[/** column name */ "WalkingArea"] = "walkingArea";
    Services_Select_Column[/** column name */ "WallCabinet"] = "wallCabinet";
})(Services_Select_Column || (Services_Select_Column = {}));
var Terraces_Select_Column;
(function(Terraces_Select_Column) {
    Terraces_Select_Column[/** column name */ "Area"] = "area";
    Terraces_Select_Column[/** column name */ "Areas"] = "areas";
    Terraces_Select_Column[/** column name */ "Counter"] = "counter";
})(Terraces_Select_Column || (Terraces_Select_Column = {}));
var Titles_Select_Column;
(function(Titles_Select_Column) {
    Titles_Select_Column[/** column name */ "Language"] = "language";
    Titles_Select_Column[/** column name */ "Text"] = "text";
})(Titles_Select_Column || (Titles_Select_Column = {}));
var Translations_Select_Column;
(function(Translations_Select_Column) {
    Translations_Select_Column[/** column name */ "Language"] = "language";
    Translations_Select_Column[/** column name */ "Value"] = "value";
})(Translations_Select_Column || (Translations_Select_Column = {}));
var Virtual_Tours_Select_Column;
(function(Virtual_Tours_Select_Column) {
    Virtual_Tours_Select_Column[/** column name */ "Url"] = "url";
})(Virtual_Tours_Select_Column || (Virtual_Tours_Select_Column = {}));
var Zones_Select_Column;
(function(Zones_Select_Column) {
    Zones_Select_Column[/** column name */ "Label"] = "label";
    Zones_Select_Column[/** column name */ "Slug"] = "slug";
})(Zones_Select_Column || (Zones_Select_Column = {}));
var AllListingsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
var ListingBySlugAndZoneDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
var FavouriteListingsDesktopDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject2());
var ListingsByFilterDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject3());
var ListingsByIdsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject4());
var ListingsBySimilarDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject5());
var ListingsCountDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject6());
var FavouriteListingsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject7());
var ListingsMarkerDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject8());
var PotentialPropertyByFilterDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject9());
var PotentialPropertiesBySimilarDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject10());
var PotentialPropertyDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject11());
var PotentialPropertiesBySuggestedCriteriaDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject12());
var defaultWrapper = function(action, _operationName, _operationType) {
    return action();
};
var AllListingsDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(AllListingsDocument);
var ListingBySlugAndZoneDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(ListingBySlugAndZoneDocument);
var FavouriteListingsDesktopDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(FavouriteListingsDesktopDocument);
var ListingsByFilterDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(ListingsByFilterDocument);
var ListingsByIdsDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(ListingsByIdsDocument);
var ListingsBySimilarDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(ListingsBySimilarDocument);
var ListingsCountDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(ListingsCountDocument);
var FavouriteListingsDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(FavouriteListingsDocument);
var ListingsMarkerDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(ListingsMarkerDocument);
var PotentialPropertyByFilterDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(PotentialPropertyByFilterDocument);
var PotentialPropertiesBySimilarDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(PotentialPropertiesBySimilarDocument);
var PotentialPropertyDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(PotentialPropertyDocument);
var PotentialPropertiesBySuggestedCriteriaDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(PotentialPropertiesBySuggestedCriteriaDocument);
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        allListings: function allListings(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(AllListingsDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "allListings", "query");
        },
        listingBySlugAndZone: function listingBySlugAndZone(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(ListingBySlugAndZoneDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "listingBySlugAndZone", "query");
        },
        favouriteListingsDesktop: function favouriteListingsDesktop(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(FavouriteListingsDesktopDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "favouriteListingsDesktop", "query");
        },
        listingsByFilter: function listingsByFilter(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(ListingsByFilterDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "listingsByFilter", "query");
        },
        listingsByIds: function listingsByIds(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(ListingsByIdsDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "listingsByIds", "query");
        },
        listingsBySimilar: function listingsBySimilar(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(ListingsBySimilarDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "listingsBySimilar", "query");
        },
        listingsCount: function listingsCount(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(ListingsCountDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "listingsCount", "query");
        },
        favouriteListings: function favouriteListings(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(FavouriteListingsDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "favouriteListings", "query");
        },
        listingsMarker: function listingsMarker(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(ListingsMarkerDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "listingsMarker", "query");
        },
        potentialPropertyByFilter: function potentialPropertyByFilter(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(PotentialPropertyByFilterDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "potentialPropertyByFilter", "query");
        },
        potentialPropertiesBySimilar: function potentialPropertiesBySimilar(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(PotentialPropertiesBySimilarDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "potentialPropertiesBySimilar", "query");
        },
        potentialProperty: function potentialProperty(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(PotentialPropertyDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "potentialProperty", "query");
        },
        potentialPropertiesBySuggestedCriteria: function potentialPropertiesBySuggestedCriteria(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(PotentialPropertiesBySuggestedCriteriaDocumentString, variables, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "potentialPropertiesBySuggestedCriteria", "query");
        }
    };
}


/***/ }),

/***/ 61414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var pino__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62096);
/* harmony import */ var pino__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pino__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(47859);

var pinoLogger = pino__WEBPACK_IMPORTED_MODULE_0___default()({
    base: {
        pid: process.pid
    },
    browser: {
        asObject: true
    },
    formatters: {
        level: function(label) {
            return {
                level: label.toUpperCase()
            };
        }
    },
    level: process.env.LISA_LOG_LEVEL || "info",
    messageKey: "message",
    timestamp: function() {
        return ',"datetime":"'.concat(new Date(Date.now()).toISOString(), '"');
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (pinoLogger);


/***/ }),

/***/ 49487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VJ": function() { return /* binding */ legacyGeoFilterToNikaFilter; },
/* harmony export */   "k": function() { return /* binding */ legacySortingToNikaSorting; },
/* harmony export */   "y2": function() { return /* binding */ legacyFiltersToNikaFilters; }
/* harmony export */ });
/* unused harmony exports rangeFilterFieldMapper, intToDateFilterFieldMapper */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65594);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62271);
// piglia i famosi filters di graphQLmmerda e traduci in emmett REST



var rangeFields = {
    byArea: "administrative_area_net",
    byBathrooms: "property_rooms_bath",
    byBedrooms: "property_rooms_bed",
    byPrice: "pricing_sell_value",
    byRooms: "property_rooms_all"
};
var intTodateFields = {
    byConstructionYear: "property_date_construction"
};
var setFields = {
    byFloor: "property_floor_position",
    byHeatingSystem: "property_system_heating",
    byResidentialType: "property_type",
    byStateAtDeed: "administrative_state_deed",
    byStateOfMaintenance: "property_state_maintenance"
};
var eqFields = {
    onlyWithBalcony: "property_feature_balcony",
    onlyWithBasement: "property_feature_basement",
    onlyWithBox: "property_feature_box",
    onlyWithConciergeService: "property_feature_concierge",
    onlyWithElevator: "property_feature_elevator",
    onlyWithGarden: "property_feature_garden",
    onlyWithParking: "property_feature_parking",
    onlyWithPool: "property_feature_pool",
    onlyWithTerrace: "property_feature_terrace"
};
var floorEnumMap = {
    BASEMENT: "basement",
    GROUND_FLOOR: "ground",
    LAST_FLOOR: "last",
    MID_FLOOR: "mid"
};
var heatingEnumMap = {
    AUTONOMOUS: "independent",
    NONE: "none",
    SHARED: "central"
};
var typeEnumMap = {
    APARTMENT: "apartment",
    ATTIC: "attic",
    HOUSE: "house",
    LOFT: "loft",
    MANSARD: "mansard",
    TOWNHOUSE: "townhouse",
    VILLA: "villa"
};
var deedEnumMap = {
    FREE: "free",
    OCCUPIED: "occupied"
};
var maintenanceEnumMap = {
    HABITABLE: "habitable",
    NEED_RENOVATION: "need_renovation",
    NEW: "new",
    RENOVATED: "renovated",
    UNDER_CONSTRUCTION: "construction"
};
var enumMaps = {
    byFloor: floorEnumMap,
    byHeatingSystem: heatingEnumMap,
    byResidentialType: typeEnumMap,
    byStateAtDeed: deedEnumMap,
    byStateOfMaintenance: maintenanceEnumMap
};
// TODO: remove geoFilter as undefined once fixed `listingMap/index.test.tsx`
function legacyGeoFilterToNikaFilter(geoFilter, target) {
    if (!geoFilter) return target;
    if (geoFilter.length === 0) return target;
    var geoFilterArray = Array.isArray(geoFilter) ? geoFilter : [
        geoFilter
    ];
    var cities = geoFilterArray.filter(function(x) {
        return x.split("/").length === 2;
    });
    var zones = geoFilterArray.filter(function(x) {
        return x.split("/").length === 3;
    });
    if (cities.length > 0 && zones.length > 0) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, target), {
            $or: [
                {
                    geo_city: {
                        $in: cities
                    }
                },
                {
                    geo_zone: {
                        $in: zones
                    }
                }
            ]
        });
    }
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, target, cities.length > 0 ? {
        geo_city: {
            $in: cities
        }
    } : {}, zones.length > 0 ? {
        geo_zone: {
            $in: zones
        }
    } : {});
}
var rangeFilterFieldMapper = function(filter) {
    return Object.keys(rangeFields).reduce(function(acc, legacyKey) {
        if (!filter[legacyKey]) return acc;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, rangeFields[legacyKey], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, filter[legacyKey].from ? {
            $gte: filter[legacyKey].from
        } : {}, filter[legacyKey].to ? {
            $lte: filter[legacyKey].to
        } : {})));
    }, {});
};
var intToDateFilterFieldMapper = function(filter) {
    return Object.keys(intTodateFields).reduce(function(acc, legacyKey) {
        if (!filter[legacyKey]) return acc;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, intTodateFields[legacyKey], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, filter[legacyKey].from ? {
            $gte: "".concat(filter[legacyKey].from, "-01-01T00:00:00Z")
        } : {}, filter[legacyKey].to ? {
            $lte: "".concat(filter[legacyKey].to, "-12-31T23:59:59Z")
        } : {})));
    }, {});
};
function legacyFiltersToNikaFilters(filter) {
    var nikaFilters = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, rangeFilterFieldMapper(filter), intToDateFilterFieldMapper(filter));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(setFields)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var legacyKey = _step.value;
            if (filter[legacyKey]) {
                var remapEnum = enumMaps[legacyKey];
                if (remapEnum !== undefined) {
                    var values = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = (filter[legacyKey] || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var value = _step1.value;
                            var mappedValue = remapEnum[value];
                            if (mappedValue !== undefined) {
                                values.push(mappedValue);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (values) {
                        nikaFilters[setFields[legacyKey]] = {
                            $in: values
                        };
                    }
                } else {
                    nikaFilters[setFields[legacyKey]] = {
                        $in: filter[legacyKey]
                    };
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = Object.keys(eqFields)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var legacyKey1 = _step2.value;
            if (filter[legacyKey1] || filter[legacyKey1] === 0) {
                nikaFilters[eqFields[legacyKey1]] = filter[legacyKey1];
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    nikaFilters = legacyGeoFilterToNikaFilter(filter.byGeoSlug, nikaFilters);
    // FIXME: check the proper combo
    if (filter.onlyCasavo === true) {
        nikaFilters["inventory"] = {
            $ne: null
        };
    }
    if (filter.onlyWithCoolingSystem === true) {
        nikaFilters["property_system_cooling"] = {
            $in: [
                "central",
                "independent",
                "ready"
            ]
        };
    }
    return nikaFilters;
}
var sortingMap = {
    AREA: "administrative_area_net",
    DATE: "created_at",
    PRICE: "pricing_sell_value",
    RANKING: "ranking"
};
function legacySortingToNikaSorting(sort) {
    var mapped = sortingMap[sort.by];
    if (sort.direction === "DESC") {
        mapped = "-".concat(mapped);
    }
    return mapped.split(",");
}


/***/ }),

/***/ 66576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ GTMEventCategory; }
/* harmony export */ });
var GTMEventCategory;
(function(GTMEventCategory) {
    GTMEventCategory["Affordability"] = "Affordability";
    GTMEventCategory["BookVisitModalForm"] = "BookVisitModalForm";
    GTMEventCategory["BuyerInterestFlow"] = "BuyerInterestFlow";
    GTMEventCategory["GeoFilterModalInCityPage"] = "ListingsFilterArea";
    GTMEventCategory["ListingDetail"] = "ListingDetail";
    GTMEventCategory["ListingsPage"] = "ListingsPage";
    GTMEventCategory["LockedPriorityDetail"] = "LockedPriorityDetail";
    GTMEventCategory["MainSearchFlow"] = "MainSearchFlow";
    GTMEventCategory["PriorityCard"] = "PriorityCard";
    GTMEventCategory["PriorityCardNotLogged"] = "PriorityCardNotLogged";
    GTMEventCategory["PriorityCarousel"] = "PriorityCarousel";
    GTMEventCategory["PriorityDetail"] = "PriorityDetail";
    GTMEventCategory["PriorityInfoBanner"] = "PriorityInfoBanner";
    GTMEventCategory["PriorityTab"] = "PriorityTab";
    GTMEventCategory["PriorityVisitModalForm"] = "PriorityVisitModalForm";
    GTMEventCategory["RelatedAdsBanner"] = "RelatedAdsBanner";
    GTMEventCategory["SimilarPropertiesCarousel"] = "SimilarPropertiesCarousel";
    GTMEventCategory["SuggestedPage"] = "SuggestedPage";
})(GTMEventCategory || (GTMEventCategory = {}));


/***/ }),

/***/ 33973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ generateUuidRequestId; }
/* harmony export */ });
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10201);

function generateUuidRequestId() {
    return (0,uuid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
}


/***/ })

}]);